export const LOGO = require('./logo.svg');
export const LOGO_WHITE = require('./logo-white.png');
export const IMAGES_LAYOUT = require('./leadership-amico.svg');
